var map = {
	"./contact-bg.jpeg": 286,
	"./gallery-4.jpg": 553,
	"./gallery.png": 566,
	"./home-2.jpg": 355,
	"./home.jpg": 692,
	"./img_parallax.jpeg": 130,
	"./notice.jpg": 953,
	"./portal.png": 400,
	"./staff.png": 625
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 852;